import { EUserAccessType, EType, IPageInfoSchema } from '../repositories/journal/entities/page_info/PageInfoSchema';

export const PageMetaPostPreviewCard: IPageInfoSchema = {
  rubricId: 0,
  category: null,
  metaTitle: '',
  metaDescription: '',
  metaKeywords: '',
  metaImage: '',
  canonicalUrl: '',
  noIndex: false,
  // TODO: поправить!!!!
  type: 'postPreviewCard' as EType,
  title: '',
  breadCrumbName: 'Превью',
  breadCrumbParents: ['/magazine/'],
  pathname: '/preview/',
  audienceAccessType: null,
  userAccessType: EUserAccessType.Unauthorised,
};
